@if (
  (isPikatukku() && (product.purchasable || !product.pikatukkuWebShopProduct)) ||
  (!isPikatukku() &&
  product.purchasable &&
  !(product.stock.stockLevelStatus === 'outOfStock' && product.similarProducts))
  ) {
  @if (product) {
    <form [formGroup]="addToCartForm">
      <div class="quantity">
        <div class="cx-counter-stock">
          <aimo-item-counter
            [readonly]="!purchasable"
            [min]="0"
            [step]="quantityStep"
            [max]="maxQuantity"
            [addToCartCallBack]="addToCartCallBack"
            [showQuantity]="showQuantity"
            [productPage]="true"
            [control]="addToCartForm.get('quantity')"
            (afterChange)="updateCart($event)"
            [buttonsClass]="'btn btn-icon btn-primary'"
            [unitName]="product.unit.name"
            [product]="product"
            [id]="'qty_' + product.code+idSuffix"
            [autofocus]="autofocus"
            [gtmProductAttributes]="gtmProductAttributes"
          [isPLP]="isPLP"></aimo-item-counter>
        </div>
      </div>
    </form>
  }
}

@if (!isPikatukku() && product.stock.stockLevelStatus === 'outOfStock') {
  @if (showAvailabilityNotification) {
    <button
        [ngbPopover]="
            product.availabilityNotificationActive
                ? ('aimo.product.removeAvailabilityNotification' | cxTranslate)
                : ('aimo.product.addAvailabilityNotificationTooltip' | cxTranslate)
        "
      container="body"
      triggers="mouseenter:mouseleave"
      popoverClass="popover-sm"
      placement="top"
      class="btn btn-secondary btn-icon availability-notification noPrint"
      type="button"
      (click)="toggleAvailabilityNotification()"
        [attr.aria-label]="
            product.availabilityNotificationActive
                ? ('aimo.product.removeAvailabilityNotification' | cxTranslate)
                : ('aimo.product.addAvailabilityNotificationTooltip' | cxTranslate)
        "
      tabindex="0">
      <i
        class="aimo-icon icon-petrol-blue icon-sm noPrint"
      [ngClass]="product.availabilityNotificationActive ? 'icon-bell-slash' : 'icon-bell'"></i>
      @if (product.availabilityNotificationActive) {
        <i class="notification-checked noPrint">
          <i class="aimo-icon icon-petrol-blue icon-xs icon-check noPrint"></i>
        </i>
      }
    </button>
  }
}
